var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg009Account(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 540 540",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M405.4,526.5c51,0,92.6-41.6,92.6-92.6,0-90.3-73.5-163.9-163.9-163.9h-128.2c-90.3,0-163.9,73.5-163.9,163.9s41.6,92.6,92.6,92.6h270.8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M156,127.5c0,63,51,114,114,114s114-51,114-114S333,13.5,270,13.5s-114,51-114,114Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg009Account);
export default __webpack_public_path__ + "static/media/009-account.5024040ee9e30db203211b29d740ecaf.svg";
export { ForwardRef as ReactComponent };